import loading from "../loading/index.js";
import { Session } from "../index.js";
import { log } from "@tumbodash/browserPackages";
import store from "../store.js";

/**
 * @async
 * @function init
 * @description Initialize a game session with socket communication and UI setup.
 * @param {object} options - Configuration options
 * @param {string} options.sessionId - Unique identifier for the game session
 * @param {string} [options.mountPoint="game-root"] - DOM element ID where the game will be mounted
 * @param {string} [options.rootPoint="root"] - DOM element ID for the root container
 * @param {Function} [options.onEnd] - Callback when game session ends
 * @returns {Promise<string>} - Resolves to the session ID
 */

async function init({
	sessionId = "",
	mountPoint = "game-root",
	rootPoint = "root",
	onEnd = () => {
		log.session("Game Complete");
	}
}: {
	sessionId?: string;
	mountPoint?: string;
	rootPoint?: string;
	onEnd?: () => void;
} = {}) {
	log.sessionFx("(client:game:init) - %s", sessionId);

	const socket = store.socket!;

	if (!sessionId) {
		throw new Error("Session ID is required to initialize the game.");
	} else if (!Session.has(sessionId)) {
		sessionId = Session.create({ sessionId });
	}

	Session.update(sessionId, { rootPoint, mountPoint, onEnd });

	loading.init(mountPoint);

	log.sessionEvent("Emit [session:join]");
	socket.emit("session:join", { data: { id: sessionId } });

	log.sessionEvent("Emit [client:ready]");
	socket.emit("client:ready", { data: { id: sessionId } });

	return sessionId;
}

export default init;
